import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "@/shared/lib/utils";

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => {
  // BP-09:Radix 把 `role="slider"` 放在 **Thumb** 上,而 `aria-label` / `aria-valuetext`
  // 写在 Root 只会落到一个**没有 role 的 span** 上 —— 读屏拿到的是「无名滑块 + 裸数字」。
  // 光在调用处写 aria-label 是没用的(源码里 grep 得到,渲染出来不生效),
  // 所以在这里把无障碍属性**转发到 Thumb**,全库所有 Slider 一次修好。
  const {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-valuetext": ariaValueText,
    ...rootProps
  } = props;
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn("relative flex w-full touch-none select-none items-center", className)}
      {...rootProps}
    >
      {/* 配色走 token;cyber 的霓虹轨道/滑块由 skin-cyber.css `.cyber-slider-*` 还原 */}
      <SliderPrimitive.Track className="cyber-slider-track relative h-2 w-full grow overflow-hidden rounded-full border border-border bg-secondary">
        <SliderPrimitive.Range className="cyber-slider-range absolute h-full rounded-full bg-primary" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        aria-valuetext={ariaValueText}
        className={cn(
          "cyber-slider-thumb block h-5 w-5 rounded-full border-2 transition-all duration-200",
          "border-primary bg-background",
          "hover:scale-110",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
          "disabled:pointer-events-none disabled:opacity-50"
        )}
      />
    </SliderPrimitive.Root>
  );
});
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
